import { 
  Form, 
  Button, 
  Select,
  Result,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { signularisApi, useCreateMetaDocumentMutation, useGetRecipientsListQuery } from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import genDocument3 from '../misc/gendoc3';
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import TextArea from "antd/lib/input/TextArea";
import style from '../CreateDocument.module.scss';
import { SendOutlined } from "@ant-design/icons";

const { Item } = Form;
const { Option } = Select;

// Генерирует случайный ID
let guid = () => {
  let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
  return s4() + s4() + s4() + s4();
}

// Форматирование даты для документа
function styledDate() {
  const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", 
                  "августа", "сентября", "октября", "ноября", "декабря"]
  const dobj = new Date()
  return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
  const info = useSelector((state: RootState) => state.userinfo)
  const dispatch = useAppDispatch()
  const { data: recipientsList } = useGetRecipientsListQuery()
  const [docname, setDocname] = useState("")
  const docTemplate : DocTemplateType = 'partTimeWork'

  const [createMetaDocument, {
    isLoading: mutationLoading, 
    isSuccess: mutationSuccess, 
    isError: mutationError,
  } ] = useCreateMetaDocumentMutation()

  const [form] = useForm()

  const onFinish = async (values: any) => {
    const regnum = guid()
    setDocname('Заявление о выходе на работу в условиях неполного рабочего времени')
    const formData = new FormData()
    formData.append("title", `Заявление о выходе на работу в условиях неполного рабочего времени №${regnum}`)
    formData.append("brief", "Сгенерировано из шаблона")
    formData.append("recipients", values.recipients.join(","))
    formData.append("documentType", docTemplate)

    values.regnum = regnum
    values.regdate = styledDate()
    values.dutyface = `${info.lastname} ${info.firstname} ${info.middlename}`
    
    const pdfBytes = await genDocument3(values, info)
    formData.append("file", new Blob([pdfBytes]))
    
    createMetaDocument(formData)
    dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
  }

  if (mutationSuccess) {
    return (
      <Result
        status="success"
        title="Документ создан"
        subTitle={`Ваш документ успешно создан.`}
        extra={[
          <Link key="back" to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}>
            <Button type="primary">Создать еще</Button>
          </Link>
        ]}
      />
    )
  }

  return (
    <div className={style.generatorWrapper}>
      <h2 className={style.title}>Заявление о выходе на работу</h2>
      <p style={{ color: '#64748b', marginBottom: 24, fontSize: 13 }}>
        В условиях неполного рабочего времени
      </p>
      
      <Form 
        form={form} 
        onFinish={onFinish} 
        layout="vertical" 
        initialValues={{regtext: "Прошу Вас считать меня вышедшей (им) на работу на условиях неполного рабочего времени ( 7 час/д или 0,5 ставки) с сохранением пособия по уходу за ребенком до достижения им возраста 1,5 лет с"}}
      >
        <Item 
            label="Получатели" 
            name="recipients" 
            rules={[{ required: true, message: 'Обязательное поле' }]}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="Выберите получателей"   
            size="large"
            filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
          >
            {recipientsList?.map((recipient) => (
                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                  {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                </Option>
            ))}
          </Select>
        </Item>

        <Item 
            label="Текст заявления" 
            className='my-input' 
            name="regtext" 
            rules={[{ required: true, message: 'Обязательное поле' }]}
        >
          <TextArea placeholder="Продолжение текста заявки" rows={5}/>
        </Item>

        <Button 
            type="primary" 
            htmlType="submit" 
            loading={mutationLoading}
            size="large"
            icon={<SendOutlined style={{ display: 'inline-flex' }} />}
            style={{ 
                width: '100%', 
                marginTop: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            Создать документ
        </Button>
      </Form>
    </div>
  )
}

export default Template;
